"use client";

import type { TenantColors } from "./types";

interface Step {
  number: number;
  title: string;
}

interface StepProgressProps {
  steps: Step[];
  currentStep: number;
  onStepClick?: (stepNumber: number) => void;
  tenantColors?: TenantColors | null;
}

export function StepProgress({ steps, currentStep, onStepClick, tenantColors }: StepProgressProps) {
  return (
    <div className="mb-8">
      <div className="flex items-center justify-between">
        {steps.map((step, index) => (
          <div key={step.number} className="flex items-center">
            <div
              className={`flex items-center justify-center w-8 h-8 rounded-full text-sm font-medium ${
                onStepClick ? "cursor-pointer" : ""
              } ${
                currentStep >= step.number
                  ? tenantColors ? "text-white" : "bg-blue-600 text-white"
                  : "bg-gray-200 text-gray-600"
              }`}
              style={currentStep >= step.number && tenantColors ? {
                backgroundColor: tenantColors.primaryColor,
              } : undefined}
              onClick={() => onStepClick?.(step.number)}
            >
              {step.number}
            </div>
            <span className="ml-2 text-sm font-medium text-gray-900">
              {step.title}
            </span>
            {index < steps.length - 1 && (
              <div
                className="flex-1 h-px mx-4"
                style={tenantColors && currentStep > step.number ? {
                  backgroundColor: tenantColors.primaryColor,
                } : { backgroundColor: '#e5e7eb' }}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
